import gql from 'graphql-tag';

export const FACEBOOK_ADS_WITH_INSIGHTS_QUERY = gql`
  query FacebookAdsWithInsightsQuery(
    $filter: FacebookAdsFilterInput!
    $insightsFilter: AdInsightsFilterInput!
    $aggregationPeriod: String!
    $attributionWindow: AttributionWindowEnum
  ) {
    facebookAds(filter: $filter) {
      id
      facebookAdId
      name
      facebookState
      adsManagerUrl
      creativeId
      origin {
        creationMethod
        anywordTemplateName
        postTextSource {
          source
          anywordTemplateId
          anywordTemplateName
        }
        headlineSource {
          source
          anywordTemplateId
          anywordTemplateName
        }
      }
      facebookAdSpentToday {
        spentToday
        discountSpentToday
      }
      article {
        id
        title
        url
        campaignId
        starred
      }
      audience {
        description
      }
      adSet {
        id
        facebookAdSetId
        adsManagerUrl
        source
      }
      insights(filter: $insightsFilter, aggregationPeriod: $aggregationPeriod, attributionWindow: $attributionWindow) {
        spendBeforeDiscount
        spendAfterDiscount
        clicks
        impressions
        ctr
        cpm
        cpc
        cpcRatio
        revenue
        revenueRoi
        profit
        pixelPageViews
        pixelSessions
        pixelAveragePageViewsPerSession
        pixelCostPerPageView
        conversions {
          id
          totalActions
          totalValue
          costPerAction
          roas
          aov
        }
      }
    }
  }
`;
